import { post } from './http';

const CONTACT_US_API_URL = '/api/contactUs';

export const sendEmail = async (formData) =>
  await post(CONTACT_US_API_URL, formData);
